@if (error) {
    <small class="color-status-red4">
        An error occurred while loading the discrepancies, please try in some
        time.
    </small>
} @else {
    <app-table
        noRowsText="No workflow items to show."
        [attr.data-qa]="dataQa.stationDiscrepancyViewTable"
        [columnDefs]="columnDefs"
        [suppressMenu]="true"
        [gridOptions]="gridOptions"
        [totalItems]="countInformation.discrepancyCount"
        (gridReady)="onGridReady($event)" />
}
